import React, {useEffect} from "react";
import OrganizationInfoForm from "../../components/Forms/OrganizationForm";

import OrganizationList from "./OrganizationList";

function OrgInputFormPage() {

  useEffect(() => {
    document.title = "Org Info";
  }, []);

  return (
    <div>
      <h2>Org Info Page</h2>
      <OrganizationList />
      <OrganizationInfoForm />
    </div>
  );
}

export default OrgInputFormPage;
